<!-- 企业级-业务领域-配置 -->
<template>
  <div class="mainArea CAccessLog">
    <div class="searchDiv mt20">
      <div>
        <el-form :inline="true" :model="keyword">
          <el-form-item label="提交时间:">
            <el-date-picker
              v-model="keyword.time"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="预约人:">
            <el-input
              v-model="keyword.person"
              placeholder="请输入姓名或手机号码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="审批人:">
            <el-input
              v-model="keyword.approver"
              placeholder="请输入姓名"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="状态:">
            <el-select
              v-model="keyword.status"
              placeholder="请选择状态"
              clearable
            >
              <el-option
                v-for="(item, index) in statusList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getAccessLog(1)">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tabList">
      <el-table :data="logList" style="width: 100%" v-loading="tableLoading">
        <el-table-column
          type="index"
          label="序号"
          width="100"
        ></el-table-column>
        <el-table-column prop="create_time" label="提交时间"></el-table-column>
        <el-table-column prop="vname" label="预约人"></el-table-column>
        <el-table-column prop="vphone" label="手机号码"></el-table-column>
        <el-table-column prop="audit_name" label="预约项目"></el-table-column>
        <el-table-column label="预约时段">
          <template slot-scope="scope">
            <span
              >{{ scope.row.start_time }} <br />
              至
              <br />{{ scope.row.end_time }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="审批人">
          <template slot-scope="scope">
            <span v-if="scope.row.user_name == ''">/</span>
            <span v-else>{{ scope.row.user_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <p v-show="scope.row.change_time != '0000-00-00 00:00:00'">
              {{ scope.row.change_time }}
            </p>
            <span>{{ scope.row.vstatus_text }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <template
              v-if="scope.row.vstatus == '0' || scope.row.vstatus == '2'"
            >
              <el-popconfirm
                confirm-button-text="确定"
                cancel-button-text="取消"
                icon="el-icon-info"
                icon-color="red"
                title="确定同意该预约吗？"
                @onConfirm="updateAudit(scope.row.id, 1)"
              >
                <el-button type="text" slot="reference">同意</el-button>
              </el-popconfirm>

              <el-popconfirm
                confirm-button-text="确定"
                cancel-button-text="取消"
                icon="el-icon-info"
                icon-color="red"
                title="确定拒绝该预约吗？"
                @onConfirm="updateAudit(scope.row.id, -1)"
              >
                <el-button type="text" slot="reference">拒绝</el-button>
              </el-popconfirm>
            </template>
            <template v-else>--</template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="paging">
      <el-pagination
        @current-change="CurrentChange"
        :current-page.sync="curr"
        :page-size="page"
        @size-change="onSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import CBreadCrumb from "../Layout/CBreadCrumb.vue";
import {
  showToast,
  updataBreadCrumb
} from "../../../../static/js/utility/utility.js";
import {
  unmanApi,
  eSiteApi,
  sceneApi,
  bussinessApi,
  userApi
} from "../../../../static/js/api.js";

export default {
  name: "CAccessLog",
  components: {
    CBreadCrumb
  },

  data() {
    return {
      keyword: {
        time: "", //提交时间
        person: "", //预约人
        approver: "", //审批人
        status: "" //状态
      },

      statusList: [
        {
          id: "0,2",
          name: "待审批"
        },

        {
          id: "-2",
          name: "已取消"
        },

        {
          id: "-1",
          name: "未通过"
        },

        {
          id: "1",
          name: "已通过"
        },

        {
          id: "-3",
          name: "已失效"
        }
      ],

      logList: [], //配置列表
      tableLoading: false,
      //分页
      curr: 1, //当前页
      page: 10, //显示个数
      total: 0 //总数据
    };
  },

  mounted() {},

  created: async function() {
    this.getAccessLog();
  },

  methods: {
    //修改预约状态
    async updateAudit(id, status) {
      let that = this;
      const data = {
        id: id,
        status: status
      };
      const res = await bussinessApi.auditorStatus(data);
      if (res.meta.code == 200) {
        that.getAccessLog();
        showToast("修改成功！");
      } else {
        showToast(res.meta.message);
      }
    },

    //获取配置设置列表
    async getAccessLog(curr, limits) {
      console.log(this.keyword.time);
      let that = this;
      this.tableLoading = true;
      const data = {
        page: curr ? curr : that.curr, //当前页
        perPage: limits ? limits : that.page, //每页条数
        start: that.keyword.time ? that.keyword.time[0] : "", //开始时间
        end: that.keyword.time ? that.keyword.time[1] : "", //结束时间
        vname: that.keyword.person, //预约人姓名跟电话查询
        user_name: that.keyword.approver, //审批人姓名
        vstatus: that.keyword.status, //状态
        code_type: "1" //1为门禁，2为会议室，默认1
      };
      let res = await bussinessApi.auditorDeviceList(data);
      if (res.meta.code == 200) {
        that.logList = res.data.list;
        that.total = parseInt(res.data.total);
        that.tableLoading = false;
      } else {
        that.tableLoading = false;
        showToast(res.meta.message);
      }
    },

    //分页
    CurrentChange(val) {
      this.curr = val;
      // console.log(`当前页: ${val}`);
      this.getAccessLog(val);
    },

    onSizeChange(val) {
      this.curr = 1;
      this.page = val;
      this.getAccessLog();
    }
  },

  watch: {
    // 监听vuex的值变化
    "$store.state.buildingID": async function(newVal, oldVal) {
      this.buildingID = newVal;
    }
  }
};
</script>

<style lang="scss">
.CAccessLog {
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CAccess/CAccessLog.vue